/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { styled } from "@iventis/styles";
import { useDragAndDropReordering } from "./use-drag-and-drop-reordering";
import { DragAndDropSortable } from "./drag-and-drop-sortable";
import { SortableListType } from "./drag-and-drop-types";
import { useDragAndDropSortable } from "./use-drag-and-drop-sortable";

type Item = { id: string };

export const DragAndDropTestingComponent = () => {
    const { sortedItems, onDragEvent } = useDragAndDropReordering([{ id: "item-1" }, { id: "item-2" }, { id: "item-3" }, { id: "item-4" }, { id: "item-5" }, { id: "item-6" }]);

    const findBottomItem = (item: Item) => item?.id;

    const onDragStart = () => null;

    const getItems = (id: string) => sortedItems.filter((item: Item) => item.id === id);

    const createOverlayComponent = (items) => <ItemGhostComponent item={items[0]} />;

    return (
        <>
            <div data-cy="dnd-sortable">
                <DragAndDropSortable<Item>
                    items={sortedItems}
                    listType={SortableListType.NORMAL}
                    getItems={getItems}
                    calculateNewParent={(id) => sortedItems.find((item) => item.id === id)}
                    findBottomItem={findBottomItem}
                    onDragStart={onDragStart}
                    onDragEnd={onDragEvent}
                    onDragOver={onDragEvent}
                    createOverlayComponent={createOverlayComponent}
                    ghostModifiers={[]}
                >
                    {sortedItems.map((item: Item) => (
                        <ItemDraggableComponent key={item.id} item={item} />
                    ))}
                </DragAndDropSortable>
            </div>
        </>
    );
};

const ItemDraggableComponent = ({ item }: { item: Item }) => {
    const { setRefs, attributes, listeners, transitionStyle, isDragging } = useDragAndDropSortable(item.id, true);

    return (
        <StyledItemContainer data-cy={item.id} ref={setRefs} style={{ ...transitionStyle, visibility: isDragging ? "hidden" : "visible" }} {...attributes} {...listeners}>
            <p>{item.id}</p>
        </StyledItemContainer>
    );
};

const ItemGhostComponent = ({ item }: { item: Item }) => (
    <StyledItemContainer data-cy="ghost">
        <p>{item.id}</p>
    </StyledItemContainer>
);

const StyledItemContainer = styled.div`
    background-color: gray;
    padding: 10px;
    margin: 10px;
    border: 1px solid black;
    user-select: none;
`;

export default DragAndDropTestingComponent;
